var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinnerLoading(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 138,
    viewBox: "0 0 137 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.497,
    cy: 109.183,
    r: 12.5,
    transform: "rotate(45 106.497 109.183)",
    fill: "#0F67BF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.9243,
    cy: 125.383,
    r: 12.5,
    transform: "rotate(90 65.9243 125.383)",
    fill: "#0F67BF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.561,
    cy: 28.5785,
    r: 12.5,
    transform: "rotate(45 107.561 28.5785)",
    fill: "#3F85CC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.673,
    cy: 69.1392,
    r: 12.5,
    transform: "rotate(90 123.673 69.1392)",
    fill: "#3F85CC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3535,
    cy: 28.9482,
    r: 12.5,
    transform: "rotate(45 28.3535 28.9482)",
    fill: "#6FA4D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.4033,
    cy: 13.3931,
    r: 12.5,
    transform: "rotate(90 67.4033 13.3931)",
    fill: "#6FA4D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.043,
    cy: 106.025,
    r: 12.5,
    transform: "rotate(45 28.043 106.025)",
    fill: "#9FC2E5"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6807,
    cy: 67.6738,
    r: 12.5,
    transform: "rotate(90 12.6807 67.6738)",
    fill: "#9FC2E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerLoading);
export default __webpack_public_path__ + "static/media/Spinner_Loading.ae8d9fb1d7d41da5d9fadb5a72d80215.svg";
export { ForwardRef as ReactComponent };